/* cxc-bag (Keith 2026-10-25): discount apply/remove for the Bag cart drawer. POST /cart/update.js { discount } with the drawer
   sections, then hand the response to Dawn's cart-drawer.renderContents so the whole drawer (bar, ticket, totals) re-renders from Liquid.
   A code Shopify reports as not applicable is removed again and the field shows the salmon error with the typed code kept in it. */
(function () {
  function drawer() { return document.querySelector('cart-drawer'); }
  function sections() { var d = drawer(); return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble']; }
  function update(code) {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code, sections: sections(), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); });
  }
  function render(state) { var d = drawer(); if (d && state && state.sections) d.renderContents(state); }
  function showError(code) {
    var f = document.querySelector('[data-cxc-bag-code]'); if (!f) return;
    var i = f.querySelector('input'), e = f.querySelector('.cxc-bag-code__error');
    if (i) { i.value = code; i.setAttribute('aria-invalid', 'true'); i.classList.add('is-error'); i.focus(); }
    if (e) e.hidden = false;
  }
  document.addEventListener('submit', function (ev) {
    var f = ev.target.closest && ev.target.closest('[data-cxc-bag-code]'); if (!f) return;
    ev.preventDefault();
    var input = f.querySelector('input'), btn = f.querySelector('button'), code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    update(code).then(function (state) {
      var hit = (state.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
      if (hit && hit.applicable) { render(state); return; }
      return update('').then(function (s2) { render(s2); showError(code); });
    }).catch(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); showError(code); });
  });
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-cxc-bag-remove]'); if (!b) return;
    b.disabled = true;
    update('').then(render).catch(function () { b.disabled = false; });
  });
  document.addEventListener('input', function (ev) {
    if (!ev.target.matches || !ev.target.matches('.cxc-bag-code__input')) return;
    ev.target.classList.remove('is-error'); ev.target.removeAttribute('aria-invalid');
    var e = document.querySelector('.cxc-bag-code__error'); if (e) e.hidden = true;
  });
})();
